(() => {
  'use strict';
  const body = document.querySelector('[data-eg-reading-body]');
  const nav = document.querySelector('[data-eg-reading-toc]');
  if (!body || !nav || nav.dataset.ready) return;
  nav.dataset.ready = 'true';
  nav.querySelectorAll('[data-eg-skel]').forEach((el) => el.remove());
  // Leave existing author-provided contents lists and all legacy anchors intact.
  const existingContents = Array.from(body.querySelectorAll('nav,.eg-toc,.table-of-contents,[id="toc"]')).some(el => el.querySelectorAll('a[href^="#"]').length >= 3);
  if (existingContents) { nav.hidden = true; return; }
  const headings = Array.from(body.querySelectorAll('h2,h3,details > summary')).filter(h => h.textContent.trim() && !h.closest('nav,aside,footer') && !(h.tagName === 'SUMMARY' && h.querySelector('h2,h3')));
  if (headings.length < 3 || body.textContent.trim().length < 900) { nav.hidden = true; return; }
  const list = nav.querySelector('ol');
  const used = new Set(Array.from(document.querySelectorAll('[id]'), el => el.id));
  headings.forEach((heading, index) => {
    if (!heading.id) {
      const base = 'yazi-' + (index + 1);
      let id = base, n = 2;
      while (used.has(id)) id = base + '-' + n++;
      heading.id = id; used.add(id);
    }
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = '#' + encodeURIComponent(heading.id);
    link.textContent = heading.textContent.trim().replace(/\s+/g, ' ');
    item.hidden = index >= 6;
    item.append(link); list.append(item);
  });
  nav.hidden = false;
  if (headings.length > 6) {
    const button = document.createElement('button'); button.type = 'button';
    list.id = 'eg-reading-toc-list';
    button.setAttribute('aria-controls', list.id); button.setAttribute('aria-expanded', 'false');
    button.textContent = nav.dataset.more;
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded)); button.textContent = expanded ? nav.dataset.less : nav.dataset.more;
      Array.from(list.children).forEach((item, index) => {item.hidden = !expanded && index >= 6;});
    }); nav.append(button);
  }
  function reveal() {
    let id; try {id = decodeURIComponent(location.hash.slice(1));} catch {return;}
    const target = id && document.getElementById(id);
    if (!target || !body.contains(target)) return;
    let parent = target.parentElement;
    while (parent && parent !== body) {if (parent.tagName === 'DETAILS') parent.open = true;parent = parent.parentElement;}
    if (target.tagName === 'SUMMARY') target.parentElement.open = true;
    target.setAttribute('tabindex', '-1');
    requestAnimationFrame(() => {target.focus({preventScroll:true});target.scrollIntoView({block:'start',behavior:'auto'});});
  }
  nav.addEventListener('click', event => {if (event.target.closest('a')) requestAnimationFrame(reveal);});
  window.addEventListener('hashchange', reveal);
  if (location.hash) reveal();
})();
